import { FederatedPointerEvent, Point } from 'pixi.js';
import { MouseButton } from './types';
import ConfigurationRenderer from './ConfigurationRenderer';

export class StageEvents {
	private core: ConfigurationRenderer;
	dragStartPoint = new Point(0, 0);

	constructor(core: ConfigurationRenderer) {
		this.core = core;

		this.core.app.stage.eventMode = 'static';
		this.core.app.stage.hitArea = this.core.app.screen;

		this.core.app.stage.on('pointermove', this.onPointerMove, this);
		this.core.app.stage.on('pointerdown', this.onPointerDown, this);
		this.core.app.stage.on('pointerup', this.onPointerUp, this);
		this.core.app.stage.on('pointerupoutside', this.onPointerUp, this);
	}

	private onPointerMove(event: FederatedPointerEvent) {}

	private onPointerDown(event: FederatedPointerEvent) {
		if (event.button === MouseButton.RIGHT) return;
	}

	private onPointerUp(event: FederatedPointerEvent) {
		this.dragStartPoint.x = 0;
		this.dragStartPoint.y = 0;
	}
}
